// Types
import type { RouteType } from "types"

// Pages
import Home from "pages/Analytics/Home"
import Key from "pages/Analytics/Key"
import { PERMISION } from "security"
import Finance from "pages/Analytics/Finance"
import Sales from "pages/Analytics/Sales"

export const analyticsRoutes: RouteType[] = [
  {
    path: "",
    element: <Home />,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "8-keys",
    element: <Key />,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "finance",
    element: <Finance />,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "sales",
    element: <Sales />,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "purchases",
    element: <div>PURCHASES</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "inventory",
    element: <div>INVENTORY</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "customers",
    element: <div>CUSTOMERS</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "vendors",
    element: <div>VENDORS</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "employee",
    element: <div>EMPLOYEE</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "marketing",
    element: <div>MARKETING</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "production",
    element: <div>PRODUCTION</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "retail",
    element: <div>RETAIL</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "warehouse",
    element: <div>WAREHOUSE</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "locations",
    element: <div>LOCATIONS</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "project",
    element: <div>PROJECT</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "tasks",
    element: <div>TASKS</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  },
  {
    path: "distributions",
    element: <div>DISTRIBUTIONS</div>,
    permission: PERMISION.ACCOUNTS.REGISTER.PERMISION
  }
]